import React, { useEffect, useState } from "react";

// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { BASE_URL } from "../utils/constants";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import Swal from "sweetalert2";
import axios from "axios";
import { PrintGrades, PrintElem } from "utils/helperFunc";
import Select from "react-select";
import parse from "html-react-parser";

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "40px",
    borderRadius: "8px",
    borderColor: state.isFocused ? "#2f6bb4" : "#cbd5e1",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(47, 107, 180, 0.15)" : "none",
    "&:hover": {
      borderColor: "#2f6bb4",
    },
    fontWeight: "500",
    fontSize: "14px",
    cursor: "pointer",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#2f6bb4" : state.isFocused ? "#f1f5f9" : "transparent",
    color: state.isSelected ? "#ffffff" : "#1e293b",
    fontSize: "14px",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
    zIndex: 9999,
  }),
};

const ProgressReport = () => {
  const [progressData, setProgessData] = useState([]);
  const [yearId, setYearId] = useState("");
  const [academicYearOptions, setAcademicYearOptions] = useState([]);
  const [academicYearData, setAcademicYearData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [isHold, setIsHold] = useState(false);
  const [report, setReport] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    setErrorMsg("");
    setIsHold(false);
    axios
      .post(`${BASE_URL}/student/getcourses.php`, {})
      .then((res) => {
        const responseData = res.data?.data || {};
        const progressReport = responseData.data || {};
        const holdFlag = responseData.is_hold || progressReport.is_hold || false;
        const err = responseData.errorMsg || progressReport.errorMsg || "";
        const holdDetected =
          holdFlag || /hold|overdue|installment|financial|finance|tuition|suspended/i.test(err);

        setIsHold(holdDetected);
        setErrorMsg(err);
        setProgessData(progressReport.grades || responseData.grades || []);
        setAcademicYearData(responseData.academicyears || []);
        setYearId(responseData.year_id || "");

        const reportHtml = progressReport.report || responseData.report;
        setReport(typeof reportHtml === "string" ? reportHtml : "");

        const newOptions = (responseData.academicyears || []).map((year) => {
          return { value: year.id, label: `${year.academicyear}` };
        });
        setAcademicYearOptions(newOptions);
        setIsLoading(false);
      })
      .catch((e) => {
        console.error("Error loading progress report:", e);
        setIsLoading(false);
        setErrorMsg("Failed to load progress report. Please try again.");
      });
  }, []);

  const handleSelectyear = (e) => {
    if (!e || e.value === yearId) return;
    setYearId(e.value);
    setIsLoading(true);
    setErrorMsg("");
    setIsHold(false);
    setReport("");

    axios
      .post(`${BASE_URL}/student/getcourses.php`, {
        year_id: e.value,
      })
      .then((res) => {
        const responseData = res.data?.data || {};
        const progressReport = responseData.data || {};
        const holdFlag = responseData.is_hold || progressReport.is_hold || false;
        const err = responseData.errorMsg || progressReport.errorMsg || "";
        const holdDetected =
          holdFlag || /hold|overdue|installment|financial|finance|tuition|suspended/i.test(err);

        setIsHold(holdDetected);
        setErrorMsg(err);
        setProgessData(progressReport.grades || responseData.grades || []);

        const reportHtml = progressReport.report || responseData.report;
        setReport(typeof reportHtml === "string" ? reportHtml : "");

        setAcademicYearData(responseData.academicyears || []);
        setYearId(responseData.year_id || e.value);

        const newOptions = (responseData.academicyears || []).map((year) => {
          return { value: year.id, label: `${year.academicyear}` };
        });
        setAcademicYearOptions(newOptions);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error changing academic year:", err);
        setIsLoading(false);
        setErrorMsg("Failed to load progress report for the selected year.");
      });
  };

  const printGrades = (selectedYearId) => {
    if (isLoading) return;

    if (isHold) {
      Swal.fire({
        title: "Report Restricted",
        text:
          errorMsg ||
          "Your progress report is currently on hold. Please contact school administration or the finance department.",
        icon: "warning",
        confirmButtonColor: "#2f6bb4",
      });
      return;
    }

    if (report) {
      PrintElem(report);
    } else if (errorMsg) {
      Swal.fire({
        title: "Unable to Print",
        text: errorMsg,
        icon: "warning",
        confirmButtonColor: "#2f6bb4",
      });
    } else {
      PrintGrades(selectedYearId);
    }
  };

  const selectedYearObj = academicYearOptions.find((f) => f.value == yearId);
  const currentYearLabel = selectedYearObj ? selectedYearObj.label : "";

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card
              className="w-100"
              style={{
                borderRadius: "14px",
                border: "none",
                boxShadow: "0 6px 20px rgba(0, 0, 0, 0.06)",
              }}
            >
              <CardHeader
                style={{
                  borderBottom: "1px solid #edf2f7",
                  padding: "20px 26px",
                  background: "#ffffff",
                  borderRadius: "14px 14px 0 0",
                }}
              >
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                  <div className="d-flex align-items-center mb-3 mb-md-0">
                    <div
                      style={{
                        width: "44px",
                        height: "44px",
                        borderRadius: "10px",
                        background: "linear-gradient(135deg, #2f6bb4 0%, #1e4b85 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#ffffff",
                        marginRight: "14px",
                        boxShadow: "0 4px 12px rgba(47, 107, 180, 0.25)",
                      }}
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                    </div>
                    <div>
                      <h4
                        className="title mb-0"
                        style={{
                          fontWeight: "700",
                          color: "#1e293b",
                          fontSize: "20px",
                        }}
                      >
                        Progress Report
                      </h4>
                      <small className="text-muted" style={{ fontSize: "13px" }}>
                        View and print official academic report card
                      </small>
                    </div>
                  </div>

                  <div className="d-flex flex-wrap align-items-center" style={{ gap: "12px" }}>
                    <div style={{ minWidth: "220px" }}>
                      <Select
                        closeMenuOnSelect={true}
                        options={academicYearOptions}
                        onChange={handleSelectyear}
                        value={selectedYearObj}
                        placeholder="Select Academic Year..."
                        styles={selectStyles}
                        isDisabled={isLoading}
                      />
                    </div>

                    <button
                      className="btn btn-primary m-0 d-inline-flex align-items-center justify-content-center"
                      style={{
                        background:
                          !report || isLoading || isHold
                            ? "#94a3b8"
                            : "linear-gradient(135deg, #2f6bb4 0%, #1e4b85 100%)",
                        borderColor: "transparent",
                        borderRadius: "8px",
                        padding: "9px 22px",
                        fontWeight: "600",
                        fontSize: "14px",
                        boxShadow:
                          !report || isLoading || isHold
                            ? "none"
                            : "0 4px 12px rgba(47, 107, 180, 0.25)",
                        cursor: !report || isLoading || isHold ? "not-allowed" : "pointer",
                        transition: "all 0.2s ease-in-out",
                        minHeight: "40px",
                      }}
                      disabled={!report || isLoading || isHold}
                      onClick={() => {
                        printGrades(yearId);
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginRight: "8px" }}
                      >
                        <polyline points="6 9 6 2 18 2 18 9"></polyline>
                        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                        <rect x="6" y="14" width="12" height="8"></rect>
                      </svg>
                      Print Report
                    </button>
                  </div>
                </div>
              </CardHeader>

              <CardBody style={{ padding: "26px", background: "#f8fafc" }}>
                {isLoading ? (
                  <div className="text-center py-5">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{
                        width: "3.2rem",
                        height: "3.2rem",
                        borderWidth: "0.28em",
                        color: "#2f6bb4",
                      }}
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                    <h5
                      className="mt-4 font-weight-bold"
                      style={{ color: "#2f6bb4", fontSize: "17px" }}
                    >
                      Loading Progress Report...
                    </h5>
                    <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                      {currentYearLabel
                        ? `Fetching academic records for ${currentYearLabel}`
                        : "Retrieving student report card..."}
                    </p>
                  </div>
                ) : isHold ? (
                  <div
                    className="p-4 my-3 text-center"
                    style={{
                      background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
                      border: "1.5px solid #fcd34d",
                      borderRadius: "12px",
                      maxWidth: "760px",
                      margin: "20px auto",
                      boxShadow: "0 6px 18px rgba(245, 158, 11, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: "60px",
                        height: "60px",
                        background: "#fef3c7",
                        borderRadius: "50%",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "16px",
                        border: "2px solid #f59e0b",
                      }}
                    >
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#d97706"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </div>
                    <h4 className="font-weight-bold mb-2" style={{ color: "#92400e" }}>
                      Progress Report Restricted
                    </h4>
                    <p
                      className="mb-3 font-weight-bold"
                      style={{
                        color: "#b45309",
                        fontSize: "15px",
                        lineHeight: "1.6",
                      }}
                    >
                      {errorMsg ||
                        "Your progress report is currently on hold. Please contact school administration or the finance department for assistance."}
                    </p>
                    <span
                      className="badge py-2 px-3"
                      style={{
                        background: "#fde68a",
                        color: "#78350f",
                        fontSize: "13px",
                        fontWeight: "600",
                        borderRadius: "20px",
                      }}
                    >
                      Administrative / Financial Hold Notice
                    </span>
                  </div>
                ) : errorMsg ? (
                  <div
                    className="p-4 my-3 text-center"
                    style={{
                      background: "#fef2f2",
                      border: "1.5px solid #fecaca",
                      borderRadius: "12px",
                      maxWidth: "760px",
                      margin: "20px auto",
                    }}
                  >
                    <h5 className="font-weight-bold text-danger mb-2">Notice</h5>
                    <p className="text-danger mb-0 font-weight-bold" style={{ fontSize: "15px" }}>
                      {errorMsg}
                    </p>
                  </div>
                ) : report ? (
                  <>
                    <style>{`
                      .progress-report-wrapper {
                        width: 100%;
                        overflow-x: auto;
                        -webkit-overflow-scrolling: touch;
                        background: #ffffff;
                        box-sizing: border-box;
                      }
                      .progress-report-content {
                        width: 100%;
                        min-width: fit-content;
                        margin: 0 auto;
                      }
                      .progress-report-content table {
                        max-width: 100% !important;
                        margin-left: auto !important;
                        margin-right: auto !important;
                        border-collapse: collapse !important;
                      }
                      .progress-report-content img {
                        max-width: 100% !important;
                        height: auto !important;
                      }
                      @media print {
                        .progress-report-wrapper {
                          box-shadow: none !important;
                          border: none !important;
                          padding: 0 !important;
                          overflow: visible !important;
                        }
                      }
                    `}</style>
                    <div
                      className="progress-report-wrapper"
                      style={{
                        background: "#ffffff",
                        borderRadius: "10px",
                        padding: "36px 32px",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                        border: "1px solid #e2e8f0",
                        minHeight: "500px",
                      }}
                    >
                      <div className="progress-report-content">
                        {parse(report)}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="text-center py-5 text-muted">
                    <h5 style={{ color: "#64748b" }}>No Report Available</h5>
                    <p style={{ fontSize: "14px" }}>
                      No progress report found for the selected academic year.
                    </p>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProgressReport;
